import * as React from 'react';
import {
  Grid,
  GridColumn as Column,
  GridSelectionChangeEvent,
  GridHeaderSelectionChangeEvent,
  getSelectedState,
  GridCellProps,
  GridNoRecords
} from '@progress/kendo-react-grid';
import { getter } from '@progress/kendo-react-common';
import { useEffect, useState } from 'react';
import {useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";


const DATA_ITEM_KEY: string = 'job_id';
const SELECTED_FIELD: string = 'selected';
const idGetter = getter(DATA_ITEM_KEY);

const ResourceTable = (props: any) => {

  const navigate = useNavigate()

  let products: {jobId: string, allocatedTo: string}[] = props.data

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [dataState, setDataState] = useState(  products && products.map((dataItem: any) =>
    Object.assign({ selected: false }, dataItem._source)    
  ));

  const redirection = (jobId: string, positionName: string, companyName: string) => {
    navigate('../position-details', { state: { jobId: jobId, positionName: positionName, companyName: companyName  }})
  }

  
  const [selectedState, setSelectedState] = useState<{
    [id: string]: boolean | number[];
  }>({});
  const [selectedCandidates, setSelectedCandidates] = useState<{name: string, job_id: string, company: string}[]>([]);

  useEffect(() => {
    setSelectedState(props.selectedState)
    setDataState(products && products.map((dataItem: any) =>
      Object.assign({ selected: false }, dataItem._source) 
    ))
  }, [products, props.selectedState])

  
  const onSelectionChange = React.useCallback(
    (event: GridSelectionChangeEvent) => {    
      const newSelectedState = getSelectedState({
        event,
        selectedState: selectedState,
        dataItemKey: DATA_ITEM_KEY,
      });  
      setSelectedState(newSelectedState);
      
      if (!event.dataItem.selected){
        let selected =  [...selectedCandidates, event.dataItem]
        setSelectedCandidates(selected)
        props.onSelection(selected)
      }else {
        const index = selectedCandidates.findIndex(item => item.job_id === event.dataItem.job_id);;
        if (index > -1) {
          selectedCandidates.splice(index, 1);
        }
        setSelectedCandidates(selectedCandidates)
        props.onSelection(selectedCandidates)
      } 
    },
    [props, selectedCandidates, selectedState]
  );

  const onHeaderSelectionChange = React.useCallback(
    (event: GridHeaderSelectionChangeEvent) => {
      const checkboxElement: any = event.syntheticEvent.target;
      const checked = checkboxElement.checked;
      const newSelectedState: any = {}
      event.dataItems.forEach((item: any) => {
        newSelectedState[idGetter(item)] = checked;
      });
      setSelectedState(newSelectedState);
      let candidates = []
      if(checked){
        candidates = event.dataItems
      }else{
        candidates = []
      }
      props.onSelection(candidates)
    },
    [props]
  )

  return (
    <div className="tableStyle">
      <Grid
        data={props.dataState && props.dataState.map((item : any) => ({
          ...item,
          [SELECTED_FIELD]: selectedState[idGetter(item)],
        }))}
        style={{ height: '400px' }}
        dataItemKey={DATA_ITEM_KEY}
        selectedField={SELECTED_FIELD}
        selectable={{
          enabled: true,
          drag: false,
          cell: false,
          mode: 'multiple',
        }}
        onSelectionChange={onSelectionChange}
        onHeaderSelectionChange={onHeaderSelectionChange}
        onPageChange={props.pageChange}
        total={props.total}
        skip={props.state.skip}
        pageable={props.state.pageable}
        pageSize={props.state.pageSize}
        onItemChange={props.itemChange}
      >
      <Column
          field={SELECTED_FIELD}
          width="50px"
          headerSelectionValue={
                      props.dataState && props.dataState.findIndex((item : any) => !selectedState[idGetter(item)]) === -1
                  }
      />
      <Column field="role" title="Role" cell={(props: GridCellProps) => nameCell(props, (candidateLoginId: string, positionName: string, companyName: string) => redirection(candidateLoginId, positionName, companyName))}/>
      <GridNoRecords>
          <div className="noData">
            <Icon icon="mdi:smiley-neutral-outline" />
            No data to display
          </div>
        </GridNoRecords>
      <Column field="experience" title="Experience" cell={experienceCell} />
      <Column field="Skills" title="Skills" cell={skillsCell} />
      <Column field="Resource required" title="Resource required" cell={recourceCountCell} />
      <Column field="profilesSubmitted" title="Profile Submitted" cell={profileSubmittedCell} />
      <Column field='position_status' title='Position Status' cell={profileCell} />
      <Column field="allocatedTo" title="Allocated To" cell={allocatedToCell}/>
      </Grid>
    </div>
  )
}

export default ResourceTable;


const nameCell = (props: GridCellProps, redirection: any) => { 
  return (
    <td onClick={() => redirection(props.dataItem.jobId, props.dataItem.positionName, props.dataItem.company)}>
       {props.dataItem.job_role && props.dataItem.job_role.name}
    </td>
  )
}

const recourceCountCell = (props: GridCellProps) => { 
  return (
    <td >
       {props.dataItem.active_count}
    </td>
  )
}

const experienceCell = (props: GridCellProps) => {
  if(props.dataItem.experience_level !== null){
    return <td>{props.dataItem.experience_level ? props.dataItem.experience_level.min + " - " + props.dataItem.experience_level.max   + " Years" : 'Not Mentioned'}</td>
  }else{
    return <td>{"Not Mentioned"}</td>;
  }
}

const skillsCell = (props: GridCellProps) => {
  let length = props.dataItem.skills && props.dataItem.skills.length;

  return (
    <td >
       <div className="skillsWrap">
        {props.dataItem.skills && props.dataItem.skills.map((item: string, key: number)  => {
           return ((item) +  (key < length-1 ?     ' , ' : ''))          })}
      </div>
    </td>
  )
}

const profileSubmittedCell = (props: GridCellProps) => {
  
  return <td>{parseInt(props.dataItem.resource_count) - props.dataItem.active_count}</td>
}

const allocatedToCell = (props: GridCellProps,) => {
  return ( 
    <td >
       {props.dataItem.allocated_to}
    </td>
  )
}

const profileCell = (props: GridCellProps) => {
  if (props.dataItem.position_status && props.dataItem.position_status.length > 0){
    return <td>
      {props.dataItem.position_status.map((item:string) => {
       return ( 
        <div className="positionList">
        <span className="status warning" />
        <strong>{`${Object.keys(item)}: ${Object.values(item)}`}</strong>
        </div>
       )
      })
       }
      </td>
    }else{
   return <td>{''}</td>
  }
}


